import MapboxClient from 'mapbox';
export default new MapboxClient(process.env.REACT_APP_MAPBOX_ACCESS_TOKEN);



// WEBPACK FOOTER //
// ./src/lib/MapboxClient.js